<template>
  <div>
    <b-table striped hover :items="esamiDisponibili" :fields="fields" responsive stacked="lg">
      <template v-slot:cell(dataEora)="row">
        <label>{{ row.item.dataAppuntamento }}</label>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: {
    esamiDisponibili: Array,
  },
  data() {
    console.log("esamiInTabella:", this.esamiDisponibili);
    return {
      fields: [
        {
          label: "Prestazione",
          key: "desPrestazione",
        },
        {
          label: "Appuntamento",
          key: "dataAppuntamento",
        },
        {
          label: "Reparto",
          key: "desStruttura",
        },
      ],
    };
  },
};
</script>
